module.exports = __webpack_public_path__ + "static/media/video-thumbnail-mobile-es.861986ba.png";